exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card .card-title{font-size:20px;font-weight:600;color:#007bff}", ""]);

